import {
  BinaryAnswerValue,
  RatingAnswerValue,
  ScoreCardFragment,
} from "@/graphql/generated/graphql";
import { deductMainSpeakers } from "@/helpers/participants/participants.helpers";
import { useCall } from "@/hooks/useCall/useCall";
import { useCurrentUser } from "@/hooks/useCurrentUser/useCurrentUser";
import { useTrack } from "@/hooks/useTrack/useTrack";

export function useTracking() {
  const { call } = useCall();
  const { track } = useTrack();
  const { currentUser } = useCurrentUser();

  const onClick = (scoreCard: ScoreCardFragment) => {
    if (!call || !call.from || !call.to) {
      return;
    }

    const { mainAgentId } = deductMainSpeakers({
      type: call.type,
      from: call.from,
      to: call.to,
    });

    track("call_evaluation_published", {
      call_id: call?.id,
      scorecard_id: scoreCard.ID,
      scorecard_name: scoreCard.name,
      total_ranged_eval_questions: scoreCard.categories.reduce(
        (acc, category) =>
          acc +
          category.questions.filter(
            (question) => question.__typename === "ScoreCardRatingQuestion"
          ).length,
        0
      ),
      total_yes_no_questions: scoreCard.categories.reduce(
        (acc, category) =>
          acc +
          category.questions.filter(
            (question) => question.__typename === "ScoreCardBinaryQuestion"
          ).length,
        0
      ),
      total_na: scoreCard.categories.reduce(
        (acc, category) =>
          acc +
          category.questions.reduce((questionAcc, question) => {
            if (question.__typename === "ScoreCardBinaryQuestion") {
              return (
                questionAcc +
                question.possibleBinaryAnswers.filter(
                  (answer) =>
                    answer.binaryValue === BinaryAnswerValue.NOT_APPLICABLE
                ).length
              );
            }

            if (question.__typename === "ScoreCardRatingQuestion") {
              return (
                questionAcc +
                question.possibleRatingAnswers.filter(
                  (answer) =>
                    answer.ratingValue === RatingAnswerValue.NOT_APPLICABLE
                ).length
              );
            }

            return questionAcc;
          }, 0),
        0
      ),
      reviewer_id: currentUser?.ID,
      reviewee_id: mainAgentId,
    });
  };

  return { onClick };
}
